<template>
  <div class="user_container">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <div id="myDiv"></div>
      </van-swipe-item>
    </van-swipe>
    <div class="flex car-foot">
      <div class="car-foot-nav flex" :style="{ backgroundImage: `url(${item.img})` }" v-for="item in list"
        :key="item.name" @click="toUseCar(item)">
        <!-- <img :src="item.img" alt="" srcset=""> -->
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "facility",
  props: {},
  components: {},
  data() {
    return {
      list: [
        {
          name: "用车申请",
          img: require("@/assets/car/facility.png"),
          path: '/car/facility/useCarApply'
        },
        {
          name: "车辆管理",
          img: require("@/assets/car/facility1.png"),
          path: '/car/facility/carManage'
        },
        {
          name: "用车明细",
          img: require("@/assets/car/facility2.png"),
          path: '/car/facility/useCarDetail'
        },
        //isShowUserId 是否显示申请用车工号输入框
        //isShowTabs 是否显示可预约 使用中 下拉框
        {
          name: "我要用车",
          img: require("@/assets/car/facility3.png"),
          path: '/car/official/index?isShowUserId=false&isShowTabs=true'
        },
        {
          name: "代申请车辆",
          img: require("@/assets/car/facility5.png"),
          path: '/car/official/index?isShowUserId=true&isShowTabs=true&minDate=true'
        },
        {
          name: "司机评价",
          img: require("@/assets/car/facility6.png"),
          path: '/car/facility/driverWeekly?isShowUserId=true&isShowTabs=true'
        },
        {
          name: "后台维护",
          img: require("@/assets/car/facility7.png"),
          path: '/car/facility/backend?isShowUserId=true&isShowTabs=true'
        },
        {
          name: "代办行程补录",
          img: require("@/assets/car/driver.png"),
          path: '/car/driver/driverRoute?type=2'
        },
      ]
    };
  },
  created() { },
  mounted() { },
  methods: {
    // 跳转用车申请
    toUseCar(item) {
      this.$router.push(item.path);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

#myDiv {
  width: 100%;
  height: 300px;
  background-image: url("~@/assets/car/facility4.png");
  /* 设置容器高度 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}

.user_container {
  min-height: 100vh;
  padding: 30px;
  margin: auto;
  font-size: 1vh;
  background-color: rgb(247 249 250);

  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .my-swipe {
    margin-bottom: 1vh;
  }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }

  .car-foot-nav {
    width: 47%;
    height: 180px;
    background: #fff;
    font-size: 29px;
    font-weight: bold;
    border-radius: 20px;
    margin: 30px 0 0 0;
    padding: 20px;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>
